import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class GlobalEventsManagerService {
  public isLoggedIn: EventEmitter<any> = new EventEmitter();
  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/service/global-events-manager.service.ts